// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__13Frs","form":"EditListingDescriptionPanel_form__2vCKe","title":"EditListingDescriptionPanel_title__3zXRf"};